class MapPoint extends HTMLElement {
    constructor() {
        super()
        this.blockGroup = this.querySelectorAll(".map-point_item")
        this.index = 0
        this.init()
    }

    init(){
        this.blockGroup.forEach((item,index)=>{
            let button = item.querySelector("button")
            button?.addEventListener("click",()=>{this.open(index)})
        })
    }

    open(index){
        if(index==this.index){
            this.blockGroup[index]?.classList.contains("active")?this.blockGroup[index]?.classList.remove("active"):this.blockGroup[index]?.classList.add("active")
            return
        }
        this.blockGroup[index]?.classList.add("active")
        this.blockGroup[this.index]?.classList.remove("active")
        this.index=index
        console.log(index)
    }
}

reg("map-point", MapPoint);